import api from '@/api/singlesheets'

const state = function () {
  return {
  }
}

// getters
const getters = {
}

// actions
const actions = {
  allDenominators ({ commit }, request) {
    return api.allDenominators(request)
  },

  allToolsUsage ({ commit }, request) {
    return api.allToolsUsage(request)
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
